// Helper function to format resolution time
export const formatResolutionTime = (days, hours, minutes) => {
  // Convert all values to numbers and handle null/undefined
  const d = days !== null && days !== undefined ? Number(days) : 0;
  const h = hours !== null && hours !== undefined ? Number(hours) : 0;
  const m = minutes !== null && minutes !== undefined ? Number(minutes) : 0;

  const parts = [];
  if (d > 0) parts.push(`${d}d`);
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}m`);

  return parts.length > 0 ? parts.join(" ") : "N/A";
};
